<template>
	<AppModal ref="imageCropModal" @close="close" :title="$t('Crop, Zoom, or Move')">
		<ImageCropper
			ref="imageCropper"
			:stencilType="stencilType"
			:aspectRatio="aspectRatio"
			:showNavigation="true"
			@imageCropped="imageCropped"
			@ready="handleReady"
			@failInit="handleCancel"
		/>

		<!-- Footer -->
		<div class="footer">
			<AppButton class="footer-button" outline @click="handleCancel" name="image_cropper_v2_cancel"
				><span class="override-text-style">{{ $t('Cancel') }}</span></AppButton
			>
			<AppButton class="footer-button" @click="handleSave" :disabled="!cropperReady" :loading="loading" name="image_cropper_v2_save"
				><span class="override-text-style">{{ $t('Use this photo') }}</span></AppButton
			>
		</div>
	</AppModal>
</template>
<script>
	import ImageCropper from './ImageCropper'

	export default {
		components: {
			ImageCropper,
		},
		props: {
			stencilType: { type: String, default: 'rectangle' },
			aspectRatio: { type: Number, default: 1 },
		},
		data() {
			return {
				cropperReady: false,
				loading: false,
			}
		},
		methods: {
			init(file) {
				this.$refs.imageCropper.init(file)
			},
			handleReady() {
				this.cropperReady = true
				this.$refs.imageCropModal.show()
			},
			handleChooseNewFile() {
				this.$refs['file-upload'].onPickFile()
			},
			handleCancel() {
				this.$emit('cancel')
				this.loading = false
				this.$refs.imageCropModal.hide()
			},
			handleSave() {
				this.loading = true
				this.$refs.imageCropper.crop()
			},
			imageCropped(data) {
				this.$emit('imageCropped', data)
				this.loading = false
				this.$refs.imageCropModal.hide()
			},
			close() {
				this.$emit('cancel')
				this.loading = false
			},
		},
	}
</script>
<style lang="scss" scoped>
	.footer {
		background-color: white;
		padding-top: 16px;
		display: flex;
		gap: 12px;
		width: 100%;
	}

	.footer-button {
		flex: 1;
		.button-content {
			.override-text-style {
				font-family: Inter !important;
				font-weight: 400 !important;
				font-size: 14px !important;
				line-height: 140% !important;
				letter-spacing: 0.2px;
			}
		}
	}
</style>

<style lang="scss">
	.image-crop-modal {
		.modal-dialog {
			.modal-content {
				.modal-header {
					padding: 15px;
					.close-modal {
						top: 5px;
						right: 0px;
					}
				}
				.modal-body {
					padding: 15px;
					padding-top: 0;
				}
			}
		}
	}
</style>
